import { generateCloudinaryUrl } from 'shared/helpers/generateCloudinaryUrl'
import { VOUCHERS_IMAGE_URL } from 'enums/vouchers'
import { Maybe } from 'shared/presenters/graphqlTypes'

export const FALLBACK_IMAGE = VOUCHERS_IMAGE_URL

const determineVoucherImage = ({
  image,
  keyImage
}: {
  image?: Maybe<string>
  keyImage?: Maybe<string>
} = {}) => {
  const src = image ?? keyImage
  if (src) return generateCloudinaryUrl(src, 'chargeable')

  return VOUCHERS_IMAGE_URL
}

export default determineVoucherImage
